import React from "react";
import { sortClasses, classRange } from "../../lib/classes";

export function ClassBadge({ cls, testid = "ir-class-badge" }) {
  if (!cls) return null;
  return <span className="cls-badge" data-testid={testid}>Class {cls.name} · {cls.pref}% pref</span>;
}

export function ClassCard({ classes, active }) {
  const s = sortClasses(classes);
  if (!s.length) return null;
  return (
    <div className="cls-strip" data-testid="ir-classes">
      <span className="cls-strip-lbl">Investment classes</span>
      {s.map((c) => (
        <span className={`cls-chip ${active && active.name === c.name && active.min === c.min ? "active" : ""}`} key={c.name + c.min} data-testid={`ir-class-${c.name}`} title={c.perk || ""}>
          <b>Class {c.name}</b> <span className="mono pos">{c.pref}%</span> <span className="mono cls-chip-range">{classRange(classes, c)}</span>{c.perk && <span className="cls-chip-perk">· {c.perk}</span>}
        </span>
      ))}
    </div>
  );
}
